// A modal or drawer takes part in browser history (WO #2440): opening it adds one entry, so the Back button (or the iPhone swipe) CLOSES it instead of leaving the page
// behind it. Closing it any other way (X, Escape, backdrop, Save) quietly removes that entry again, so there is no dead Back press left over.
// The entry is added a tick after opening so React StrictMode's double mount in development never leaves two.
// layer: a card or page-level drawer is layer 0, an overlay that sits above it (a Modal, the composer) is layer 1. When both open in the same render (a contact
// opened straight into Edit) a child's effect runs before its parent's, so without this the overlay's entry would sit UNDER the card's and Back would close
// the card but leave the overlay up. A higher layer adds its entry later, so it is always on top and Back closes it first.
import { useEffect, useRef } from 'react';

let counter = 0;

export function useBackToClose(open, onClose, layer = 0) {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    if (!open || typeof window === 'undefined') return undefined;
    counter += 1;
    const id = `m${counter}`;
    let pushed = false;
    const timer = setTimeout(() => {
      try {
        window.history.pushState({ ...(window.history.state || {}), charlieModal: id }, '');
        pushed = true;
      } catch (e) { /* history unavailable: the modal still closes the usual ways */ }
    }, layer * 5);
    const onPop = () => {
      // our entry is gone (Back was pressed): close. A modal stacked above this one popping leaves OUR entry on top, so we stay open.
      if (pushed && !(window.history.state && window.history.state.charlieModal === id)) {
        pushed = false;
        if (closeRef.current) closeRef.current();
      }
    };
    window.addEventListener('popstate', onPop);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('popstate', onPop);
      // closed some other way while our entry is still the current one: take it out so Back does not do nothing once
      if (pushed && window.history.state && window.history.state.charlieModal === id) window.history.back();
    };
  }, [open, layer]);
}
